import { NoResult } from 'ui/illustrations';
import { PlaceholderState } from 'ui/indexPages/PlaceholderState';

export const GoalsNoResultsState = () => (
  <PlaceholderState id="goal-index-no-results" title="No matching results" Illustration={NoResult}>
    Try adjusting your filters or searching by different keywords.
  </PlaceholderState>
);
